<template>
  <span>{{ fechaCompromiso }}</span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "FechaCompromisoComponent",
  computed: {
    fechaCompromiso() {
      if (this.params.data.fecha_compromiso)
        return this.$moment(this.params.data.fecha_compromiso).format(
          "ddd DD/MM/YYYY",
        );
      return "";
    },
  },
});
</script>

<style scoped></style>
